import React from 'react';
import { Link } from 'react-router-dom';
import { GHG_INVENTORY_REPORT_ENABLED } from '../../config/ghgInventoryReportFeature';
import { ghgInventoryReportPreviewState } from '../../domains/ghgInventoryReport';
import './GhgInventoryReportPreviewLink.css';

export function GhgInventoryReportPreviewLink({
  geofips,
  enabled = GHG_INVENTORY_REPORT_ENABLED,
}: {
  geofips: number | null;
  enabled?: boolean;
}) {
  const state = ghgInventoryReportPreviewState(geofips, enabled);
  if (state.kind === 'hidden') return null;

  if (state.kind === 'city_only') {
    return (
      <p className="ghg-report-preview ghg-report-preview--disabled no-print" role="note">
        {state.message}
      </p>
    );
  }

  return (
    <p className="ghg-report-preview no-print">
      <Link className="ghg-report-preview__link" to={state.href}>
        {state.label}
      </Link>
    </p>
  );
}
